<template>
  <router-link
    :class="$options.name"
    :to="{ name: 'Build', params: { build: formatLink(title) }}"
    :aria-label="'Read more about ' + title"
  >
    <figure :class="$options.name + '__img'">
      <img v-if="img" :src="img + '?fm=jpg&fl=progressive&fit=fill&w=960&h=540'" :alt="'Hero image for ' + title">
      <Loader v-else/>
    </figure>
    <figcaption :class="$options.name + '__caption'">
      <h3>{{ title }}</h3>
      <Icon name="arrow-right" :size="14"/>
    </figcaption>
  </router-link>
</template>
<script>
import Icon from "@/components/Icon";
import Loader from "@/components/Loader";
export default {
  name: "BuildTile",
  components: { Icon, Loader },
  methods: {
    formatLink(value) {
      return value.toLowerCase().replace(/[^A-Za-z0-9']/g, "");
    }
  },
  props: {
    img: { default: "" },
    path: { default: "" },
    title: { default: "" }
  }
};
</script>
<style lang="scss">
.BuildTile {
  max-width: rem(640);
  padding-bottom: rem(24);
  padding-right: rem(16);
  position: relative;
  width: 100%;
  &:focus,
  &:hover {
    .BuildTile__caption {
      color: var(--highlight);
    }
    .BuildTile__img {
      &:nth-of-type(odd) img {
        transform: rotate(-1deg) scale(1.0625);
      }
      &:nth-of-type(even) img {
        transform: rotate(1deg) scale(1.0625);
      }
    }
  }
  &__img {
    background-color: var(--contrast);
    border-radius: rem(4);
    box-shadow: 0 rem(16) rem(32) rem(-16) rgba(black, 0.5);
    overflow: hidden;
    img {
      transform-origin: 50% 50%;
      transition: transform 0.375s ease-in;
    }
  }
  &__caption {
    @include smooth;
    align-items: center;
    background-color: var(--base);
    border-radius: rem(4);
    bottom: 0;
    color: white;
    display: flex;
    height: rem(48);
    justify-content: space-between;
    left: rem(16);
    padding: 0 rem(16);
    position: absolute;
    right: 0;
    [data-theme="dark"] & {
      background-color: var(--contrast);
    }
    h3 {
      flex-shrink: 1;
      max-width: 100%;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
    .Icon {
      flex-shrink: 0;
      margin-left: rem(8);
    }
  }
}
</style>